export enum AvatarType {
    CONNECTED = 'connected',
    LINKED = 'linked',
    UNLINKED = 'unlinked'
}
